const data = [
  {
    id: 'dashboards',
    icon: 'iconsminds-bar-chart-4 d-block',
    label: 'menu.dashboards',
    to: '/app/dashboards/analytics',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'BusinessOperator',
      'QuarantineBot',
      'VoucherEngine',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
      'Activities',
      'Restaurant',
      'UtilityProviders',
    ],
  },
  {
    id: 'conversations',
    icon: 'iconsminds-speach-bubbles',
    label: 'menu.conversations.unified-inbox',
    // to: '/app/pages/conversations',
    to: '/app/pages/agent-assist',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'BusinessOperator',
      'Northable',
      'Golf',
      'Activities',
      'Restaurant',
      'UtilityProviders',
    ],
  },

  {
    id: 'propinfo',
    icon: 'simple-icon-book-open',
    label: 'menu.propinfo',
    image: 'knowlegeHub',
    to: '/app/pages/propinfo',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
      'VoucherEngine',
      'Activities',
      'Restaurant',
      'UtilityProviders',
      'BusinessOperator',
    ],
    subs: [
      {
        icon: 'iconsminds-cursor-select',
        label: 'property-info.pre-built-templates',
        to: '/app/pages/propinfo/favourite-response',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'VoucherEngine',
          'Activities',
          'Restaurant',
        ],
        filter: 'training',
        count: '0',
      },
      {
        icon: 'iconsminds-home',
        label: 'property-info.room-types',
        to: '/app/pages/propinfo/about-rooms',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'QuarantineBot',
          'HolidayHomes',
          'VoucherEngine',
          'Restaurant',
          'HolidaysPark',
        ],
        filter: 'training',
        count: '6',
      },
      {
        icon: 'iconsminds-air-balloon-1',
        label: 'menu.favourites',
        to: '/app/pages/propinfo/favourite-response',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
        ],
        filter: 'training',
        count: '0',
      },
      {
        icon: 'iconsminds-information',
        label: 'property-info.about-property',
        to: '/app/pages/propinfo/about-property',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '26',
      },
      {
        icon: 'iconsminds-information',
        label: 'property-info.about-property',
        to: '/app/pages/propinfo/golf-property',
        domains: ['Golf'],
        filter: 'training',
        count: '25',
      },
      {
        icon: 'iconsminds-information',
        label: 'property-info.about-rhproperty',
        to: '/app/pages/propinfo/about-rhproperty',
        domains: ['RetirementHomes'],
        filter: 'training',
        count: '56',
      },

      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/hotel-group-assistant-options',
        domains: ['AccommodationProvidersGroup'],
        filter: 'training',

        count: '1',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/hh-group-assistant-options',
        domains: ['HolidayHomesGroup'],
        filter: 'training',
        count: '1',
      },
      {
        icon: 'iconsminds-information',
        label: 'property-info.about-properties',
        to: '/app/pages/propinfo/about-group-property',
        domains: ['AllGroups'],
        filter: 'training',
        count: '24',
      },
      {
        icon: 'iconsminds-information',
        label: 'Salon Information',
        to: '/app/pages/propinfo/salon-information',
        domains: ['Salons'],
        filter: 'training',
        count: '13',
      },
      {
        icon: 'iconsminds-chair',
        label: 'Service Categories',
        to: '/app/pages/propinfo/salon-services',
        domains: ['Salons'],
        filter: 'training',
        count: '9',
      },
      // {
      //   icon: 'iconsminds-gift-box',
      //   label: 'Services',
      //   to: '/app/pages/propinfo/services',
      //   domains: ['Salons'],
      // },
      // {
      //   icon: 'iconsminds-clinic',
      //   label: 'Services',
      //   to: '/app/pages/propinfo/services',
      //   domains: ['Doctors'],
      // },
      // {
      //   icon: 'iconsminds-gift-box',
      //   label: 'Services Catalog',
      //   to: '/app/pages/propinfo/services',
      //   domains: ['AccommodationProviders'],
      // },
      {
        icon: 'iconsminds-gift-box',
        label: 'Services',
        to: '/app/pages/propinfo/golf-services',
        domains: ['Golf'],
        count: '18',
      },
      {
        icon: 'iconsminds-home',
        label: 'General',
        to: '/app/pages/propinfo/golf-general',
        domains: ['Golf'],
        count: '26',
      },
      // {
      //   icon: 'iconsminds-gift-box',
      //   label: 'menu.guestservice',
      //   to: '/app/pages/propinfo/services',
      //   domains: ['QuarantineBot'],
      // },
      {
        icon: 'iconsminds-location-2',
        label: 'property-info.loction',
        to: '/app/pages/propinfo/locations',
        domains: ['Salons', 'Doctors'],
        filter: 'training',
        count: '0',
      },
      {
        icon: 'iconsminds-building',
        label: 'property-info.property-facilities',
        to: '/app/pages/propinfo/property-facilities',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '26',
      },
      {
        icon: 'iconsminds-home-1',
        label: 'property-info.room-amenities',
        to: '/app/pages/propinfo/room-amenities',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '17',
      },
      {
        icon: 'iconsminds-information',
        label: 'property-info.home-information',
        to: '/app/pages/propinfo/hh-information',
        domains: ['HolidayHomes'],
        filter: 'training',
        count: '24',
      },
      {
        icon: 'iconsminds-home-1',
        label: 'Facilities',
        to: '/app/pages/propinfo/hh-amenities',
        domains: ['HolidayHomes'],
        filter: 'training',
        count: '16',
      },
      {
        icon: 'iconsminds-bird-delivering-letter',
        label: 'property-info.property-contact',
        to: '/app/pages/propinfo/property-contact',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '7',
      },

      // {
      //   icon: 'iconsminds-plane',
      //   label: 'property-info.copilot',
      //   to: '/app/pages/propinfo/copilot',
      //   domains: [
      //     'AccommodationProviders',
      //     'RetirementHomes',
      //     'QuarantineBot',
      //     'Tourism',
      //     'HolidaysPark',
      //     'HolidayHomes',
      //     'Activities',
      //     'AllGroups',
      //     'Restaurant',
      //   ],
      //   filter: 'copilot'
      // },
      {
        icon: 'iconsminds-gymnastics',
        label: 'property-info.property-activities',
        to: '/app/pages/propinfo/property-activities',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '5',
      },
      {
        icon: 'iconsminds-location-2',
        label: 'property-info.property-location',
        to: '/app/pages/propinfo/property-location',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '6',
      },
      // {
      //   icon: 'iconsminds-mail-3',
      //   label: 'property-info.channel-messages',
      //   to: '/app/pages/propinfo/hotel-channels',
      //   domains: ['AccommodationProviders'],
      //   filter: 'flow',
      // },
      {
        icon: 'iconsminds-information',
        label: 'About',
        to: '/app/pages/propinfo/hp-information',
        domains: ['HolidaysPark'],
        filter: 'training',
        count: '24',
      },
      {
        icon: 'iconsminds-building',
        label: 'Facilities',
        to: '/app/pages/propinfo/hp-facilities',
        domains: ['HolidaysPark'],
        filter: 'training',
        count: '21',
      },
      {
        icon: 'iconsminds-information',
        label: 'About',
        to: '/app/pages/propinfo/vvn-information',
        domains: ['VirtualVetNurse'],
        filter: 'training',
        count: '12',
      },
      {
        icon: 'iconsminds-information',
        label: 'Facilities & Contacts',
        to: '/app/pages/propinfo/qbot-information',
        domains: ['QuarantineBot'],
        filter: 'training',
        count: '26',
      },
      {
        icon: 'iconsminds-location-2',
        label: 'Location',
        to: '/app/pages/propinfo/hp-location',
        domains: ['HolidaysPark'],
        filter: 'training',
        count: '9',
      },
      {
        icon: 'iconsminds-bird-delivering-letter',
        label: 'Contact',
        to: '/app/pages/propinfo/hp-contact',
        domains: ['HolidaysPark'],
        filter: 'training',
        count: '6',
      },
      {
        icon: 'iconsminds-information',
        label: 'Checked-In',
        to: '/app/pages/propinfo/property-front-desk',
        domains: ['HolidaysPark'],
        filter: 'training',
        count: '10',
      },
      // {
      //   icon: 'iconsminds-satelite-2',
      //   label: 'response-test',
      //   to: '/app/pages/propinfo/response-test',
      // },
      {
        icon: 'iconsminds-ambulance',
        label: 'property-info.special-emergencies',
        to: '/app/pages/propinfo/emergencies',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '2',
      },
      // {
      //   icon: 'iconsminds-home',
      //   label: 'property-info.about-rooms',
      //   to: '/app/pages/propinfo/about-rooms',
      //   domains: [
      //     'AccommodationProviders',
      //     'RetirementHomes',
      //     'QuarantineBot',
      //     'HolidayHomes',
      //     'VoucherEngine',
      //     'Restaurant',
      //   ],
      //   filter: 'rooms',
      // },

      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/assistant-options',
        domains: ['RetirementHomes'],
        filter: 'training',
        count: '3',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/vvn-assistant-options',
        domains: ['VirtualVetNurse'],
        filter: 'training',
        count: '5',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/hp-assistant-options',
        domains: ['HolidaysPark'],
        filter: 'training',
        count: '3',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/hotel-assistant-options',
        domains: ['AccommodationProviders'],
        filter: 'training',
        count: '4',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/qbot-assistant-options',
        domains: ['QuarantineBot'],
        filter: 'training',
        count: '2',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/salon-assistant-options',
        domains: ['Salons'],
        filter: 'training',
        count: '2',
      },
      {
        icon: 'iconsminds-information',
        label: 'Activities Information',
        to: '/app/pages/propinfo/activities-assistant-information',
        domains: ['Activities'],
        filter: 'training',
        count: '44',
      },
      {
        icon: 'iconsminds-book',
        label: 'menu.formbuilder',
        to: '/app/pages/propinfo/forms',
        domains: ['Activities', 'Restaurant'],
        filter: 'flow',
      },
      // {
      //   icon: 'iconsminds-three-arrow-fork',
      //   label: 'Menus',
      //   to: '/app/pages/propinfo/messenger',
      //   domains: ['Activities'],
      //   filter: 'flow',
      // },
      // {
      //   icon: 'iconsminds-three-arrow-fork',
      //   label: 'virtual-messenger',
      //   to: '/app/pages/propinfo/messenger',
      //   domains: ['Restaurant'],
      //   filter: 'flow',
      // },
      {
        icon: 'iconsminds-life-safer',
        label: 'Conversation Start',
        to: '/app/pages/propinfo/activities-assistant-options',
        domains: ['Activities'],
        filter: 'training',
        count: '4',
      },
      {
        icon: 'iconsminds-information',
        label: 'menu.about',
        to: '/app/pages/propinfo/restaurant-assistant-information',
        domains: ['Restaurant'],
        filter: 'training',
        count: '35',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.restaurant-assistant-options',
        to: '/app/pages/propinfo/restaurant-assistant-options',
        domains: ['Restaurant'],
        filter: 'training',
      },
      {
        icon: 'iconsminds-gift-box',
        label: 'Services',
        to: '/app/pages/propinfo/northable-about',
        domains: ['Northable'],
      },
      {
        icon: 'iconsminds-equalizer',
        label: 'Equipment',
        to: '/app/pages/propinfo/northable-equipment',
        domains: ['Northable'],
      },
      {
        icon: 'iconsminds-laptop---phone',
        label: 'Helplines',
        to: '/app/pages/propinfo/northable-helpline',
        domains: ['Northable'],
      },
      {
        icon: 'iconsminds-newspaper',
        label: 'Policies',
        to: '/app/pages/propinfo/hh-policies',
        domains: ['HolidayHomes'],
        filter: 'training',
        count: '5',
      },
      {
        icon: 'iconsminds-photo',
        label: 'property-info.gallery',
        to: '/app/pages/propinfo/gallery',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'Doctors',
          'Golf',
          'VoucherEngine',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'rooms',
      },
      {
        icon: 'iconsminds-like',
        label: 'property-info.icon.gallery',
        to: '/app/pages/propinfo/icon-gallery',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'Doctors',
          'Golf',
          'VoucherEngine',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'rooms',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/hh-assistant-options',
        domains: ['HolidayHomes'],
        filter: 'training',
        count: '3',
      },
      {
        icon: 'iconsminds-testimonal',
        label: 'menu.recommender',
        to: '/app/pages/propinfo/recommender',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'flow',
      },
      {
        icon: 'iconsminds-files',
        label: 'virtual-messenger',
        to: '/app/pages/propinfo/messenger',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidaysPark',
          'HolidayHomes',
          'Restaurant',
          'AllGroups',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'widget',
      },
      // {
      //   icon: 'iconsminds-shopping-cart',
      //   label: 'Products',
      //   to: '/app/pages/propinfo/products',
      //   domains: ['Tourism', 'Activities', 'Restaurant', 'Doctors'],
      //   filter: 'training',
      // },

      // {
      //   icon: 'iconsminds-doctor',
      //   label: 'Doctors',
      //   to: '/app/pages/propinfo/products',
      //   domains: ['Doctors'],
      // },
      {
        icon: 'iconsminds-information',
        label: 'Clinic Information',
        to: '/app/pages/propinfo/clinic-information',
        domains: ['Doctors'],
        filter: 'training',
        count: '27',
      },
      {
        icon: 'iconsminds-voice',
        label: 'Voice Responses',
        to: '/app/pages/propinfo/dc-voice',
        domains: ['Doctors'],
        filter: 'training',
        count: '16',
      },
      {
        icon: 'iconsminds-life-safer',
        label: 'property-info.assistant-options',
        to: '/app/pages/propinfo/dc-assistant-options',
        domains: ['Doctors'],
        filter: 'training',
        count: '2',
      },
      {
        icon: 'iconsminds-chair',
        label: 'property-info-utility-miscellaneous',
        to: '/app/pages/propinfo/property-miscellaneous',
        domains: ['AccommodationProviders', 'HolidaysPark'],
        filter: 'training',
        count: '35',
      },
      {
        icon: 'iconsminds-brush',
        label: 'property-info.add-your-own',
        to: '/app/pages/propinfo/hotel-bio',
        domains: ['AccommodationProviders', 'HolidayHomes'],
        filter: 'training',
        count: '5',
      },
      {
        icon: 'iconsminds-brush',
        label: 'property-info.add-your-own',
        to: '/app/pages/propinfo/camping-bio',
        domains: ['HolidaysPark', 'Restaurant'],
        filter: 'training',
        count: '5',
      },
      {
        icon: 'iconsminds-brush',
        label: 'property-info.add-your-own',
        to: '/app/pages/propinfo/activities-bio',
        domains: ['Activities'],
        filter: 'training',
        count: '5',
      },
      // {
      //   icon: 'iconsminds-home',
      //   label: 'Rooms',
      //   to: '/app/pages/propinfo/about-rooms',
      //   domains: ['HolidaysPark'],
      //   filter: 'training',
      // },
      {
        icon: 'iconsminds-shopping-cart',
        label: 'menu.product_services',
        to: '/app/pages/propinfo/products',
        domains: [
          'AccommodationProviders',
          'HolidaysPark',
          'Tourism',
          'Activities',
          'Restaurant',
          'Doctors',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'training',
        count: '0',
      },
      {
        icon: 'iconsminds-paper',
        label: 'property-info.documents',
        to: '/app/pages/documents',
        domains: [
          'AccommodationProviders',
          'Restaurant',
          'HolidaysPark',
          'Activities',
          'HolidayHomes',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'training',
        count: '0',
      },
      {
        icon: 'iconsminds-testimonal',
        label: 'property-info.faq',
        to: '/app/pages/faq',
        domains: [
          'AccommodationProviders',
          'Restaurant',
          'HolidaysPark',
          'Activities',
          'HolidayHomes',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'training',
        count: '0',
      },
      {
        icon: 'iconsminds-repeat-3',
        label: 'property-info.external-sources',
        to: '/app/pages/external-sources',
        domains: [
          'AccommodationProviders',
          'Restaurant',
          'HolidaysPark',
          'Activities',
          'HolidayHomes',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'training',
        count: '0',
      },
      {
        icon: 'simple-icon-rocket',
        label: 'property-info.publish-ai',
        to: '/app/pages/propinfo/publish-ai',
        domains: [
          'AccommodationProviders',
          'Restaurant',
          'HolidaysPark',
          'Activities',
          'HolidayHomes',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'publish',
        count: '0',
      },
      {
        icon: 'simple-icon-magnifier-add',
        label: 'menu.conversations.missed-responses',
        to: '/app/pages/missed-responses',
        domains: [
          'AccommodationProviders',
          'Restaurant',
          'HolidaysPark',
          'Activities',
          'HolidayHomes',
          'UtilityProviders',
          'BusinessOperator',
        ],
        filter: 'publish',
        count: '0',
      },
      // {
      //   icon: 'iconsminds-file-clipboard-file---text',
      //   label: 'property-info.policies',
      //   to: '/app/pages/propinfo/policies',
      // },
      // {
      //   icon: 'iconsminds-edit-map',
      //   label: 'property-info.nearby',
      //   to: '/app/pages/propinfo/nearby',
      // },
      // {
      //   icon: 'iconsminds-car',
      //   label: 'property-info.transport',
      //   to: '/app/pages/propinfo/transport',
      // },
      // {
      //   icon: 'iconsminds-location-2',
      //   label: 'property-info.location',
      //   to: '/app/pages/propinfo/location',
      // },
    ],
  },
  {
    id: 'workflows',
    icon: 'simple-icon-grid d-block',
    label: 'menu.workflows',
    to: '/app/pages/propinfo/services',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
      'VoucherEngine',
      'Activities',
      'Restaurant',
      'UtilityProviders',
      'BusinessOperator',
    ],
    // domains: ['UtilityProviders', 'BusinessOperator'],
    subs: [
      // {
      //     icon: 'iconsminds-management',
      //     label: 'menu.product_services',
      //     to: '/app/pages/propinfo/products',
      //     domains: ['UtilityProviders', 'BusinessOperator'],
      // },

      // {
      //   icon: 'iconsminds-files',
      //   label: 'virtual-messenger',
      //   to: '/app/pages/propinfo/messenger',
      //   domains: [
      //     'AccommodationProviders',
      //     'Salons',
      //     'Doctors',
      //     'Activities',
      //     'HolidaysPark',
      //     'HolidayHomes',
      //     'Restaurant',
      //     'AllGroups',
      //     'UtilityProviders',
      //     'BusinessOperator'
      //   ],
      //   filter: 'widget'
      // },
      // {
      //   icon: 'iconsminds-mail-3',
      //   label: 'property-info.channel-messages',
      //   to: '/app/pages/propinfo/hotel-channels',
      //   domains: ['AccommodationProviders'],
      //   filter: 'widget'
      // },
      {
        icon: 'iconsminds-book',
        label: 'menu.formbuilder',
        to: '/app/pages/propinfo/forms',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      {
        icon: 'iconsminds-shuffle-2',
        label: 'menu.recommender',
        to: '/app/pages/propinfo/recommender',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      // {
      //     icon: 'iconsminds-gift-box',
      //     label: 'menu.digital_guide_book',
      //     to: '/app/pages/propinfo/services',
      //     domains: ['BusinessOperator', 'UtilityProviders'],
      // },
      // {
      //   icon: 'iconsminds-inbox-out',
      //   label: 'virtual-front.outbound',
      //   to: '/app/pages/propinfo/outbound',
      //   domains: [
      //     'AccommodationProviders',
      //     'RetirementHomes',
      //     'Salons',
      //     'HolidaysPark',
      //     'QuarantineBot',
      //     'HolidayHomes',
      //     'VirtualVetNurse',
      //     'AllGroups',
      //     'Tourism',
      //     'Doctors',
      //     'Northable',
      //     'Golf',
      //     'Activities',
      //     'Restaurant',
      //     'UtilityProviders',
      //     'BusinessOperator',
      //   ],
      // },
    ],
  },
  {
    id: 'virtualfrontdesk',
    icon: 'iconsminds-qr-code d-block',

    label: 'virtual-front.guest-service-add-on-upsells',
    to: '/app/pages/propinfo/services',
    domains: [
      'AccommodationProviders',
      'Salons',
      'Doctors',
      'Activities',
      'HolidaysPark',
      'HolidayHomes',
      'Restaurant',
      'UtilityProviders',
      'BusinessOperator',
    ],
    subs: [
      {
        icon: 'iconsminds-files',
        label: 'menu.content-manager',
        to: '/app/pages/propinfo/services',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidaysPark',
          'HolidayHomes',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      {
        icon: 'iconsminds-calendar-1',
        label: 'menu.events-calendar',
        to: '/app/pages/propinfo/EventCalendar',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidaysPark',
          'HolidayHomes',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      {
        icon: 'simple-icon-screen-smartphone',
        label: 'menu.appearance-settings',
        to: '/app/pages/integration/applications',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VoucherEngine',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'BusinessOperator',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-photo',
        label: 'property-info.gallery',
        to: '/app/pages/propinfo/gallery',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'Doctors',
          'Golf',
          'VoucherEngine',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      {
        icon: 'iconsminds-like',
        label: 'property-info.icon.gallery',
        to: '/app/pages/propinfo/icon-gallery',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'Doctors',
          'Golf',
          'VoucherEngine',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      {
        icon: 'iconsminds-lock-2',
        label: 'menu.members',
        to: '/app/pages/members',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidaysPark',
          'HolidayHomes',
        ],
      },
      {
        icon: 'simple-icon-envelope',
        label: 'menu.guest-pass',
        to: '/app/pages/propinfo/guest-pass',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidaysPark',
          'HolidayHomes',
        ],
      },
      {
        icon: 'iconsminds-information',
        label: 'menu.help',
        to: 'https://help.myma.ai/en/collections/5421108-digital-compendium',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidaysPark',
          'HolidayHomes',
          'Restaurant',
        ],
        newWindow: true,
      },
    ],
  },
  // {
  //   id: 'workflows',
  //   icon: 'iconsminds-police d-block',
  //   label: 'menu.workflows',
  //   to: '/app/pages/propinfo/services',
  //   domains: ['UtilityProviders', 'BusinessOperator'],
  //   subs: [
  //     {
  //       icon: 'iconsminds-management',
  //       label: 'menu.product_services',
  //       to: '/app/pages/propinfo/products',
  //       domains: ['UtilityProviders', 'BusinessOperator'],
  //     },
  //     {
  //       icon: 'iconsminds-testimonal',
  //       label: 'menu.recommender',
  //       to: '/app/pages/propinfo/recommender',
  //       domains: ['UtilityProviders', 'BusinessOperator'],
  //     },
  //     {
  //       icon: 'iconsminds-gift-box',
  //       label: 'virtual-messenger',
  //       to: '/app/pages/propinfo/messenger',
  //       domains: ['UtilityProviders', 'BusinessOperator'],
  //     },
  //     {
  //       icon: 'iconsminds-book',
  //       label: 'menu.formbuilder',
  //       to: '/app/pages/propinfo/forms',
  //       domains: ['UtilityProviders', 'BusinessOperator'],
  //     },
  //     {
  //       icon: 'iconsminds-gift-box',
  //       label: 'menu.digital_guide_book',
  //       to: '/app/pages/propinfo/services',
  //       domains: ['BusinessOperator', 'UtilityProviders'],
  //     },
  //   ],
  // },
  // {
  //   id: 'conversations',
  //   icon: 'iconsminds-speach-bubble d-block',
  //   label: 'menu.conversations.unified-inbox',
  //   to: '/app/pages/conversations',
  //   domains: [
  //     'AccommodationProviders',
  //     'RetirementHomes',
  //     'Salons',
  //     'HolidaysPark',
  //     'QuarantineBot',
  //     'HolidayHomes',
  //     'VirtualVetNurse',
  //     'AllGroups',
  //     'Tourism',
  //     'Doctors',
  //     'BusinessOperator',
  //     'Northable',
  //     'Golf',
  //     'Activities',
  //     'Restaurant',
  //     'UtilityProviders',
  //   ],
  //   subs: [
  //     {
  //       icon: 'iconsminds-user',
  //       label: 'menu.conversations.active',
  //       to: '/app/pages/agent-assist',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'HolidaysPark',
  //         'QuarantineBot',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'BusinessOperator',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'Restaurant',
  //         'UtilityProviders',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-speach-bubble-dialog',
  //       label: 'menu.conversations.archives',
  //       to: '/app/pages/conversations/archives',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'HolidaysPark',
  //         'QuarantineBot',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'BusinessOperator',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'Restaurant',
  //         'UtilityProviders',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-check',
  //       label: 'menu.conversations.ticket',
  //       to: '/app/pages/conversations/tickets',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'HolidaysPark',
  //         'QuarantineBot',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'BusinessOperator',
  //         'Restaurant',
  //         'UtilityProviders',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-speach-bubble-asking',
  //       label: 'menu.conversations.missed-responses',
  //       to: '/app/pages/conversations/missingresponse',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'HolidaysPark',
  //         'QuarantineBot',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'Restaurant',
  //         'UtilityProviders',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-notepad',
  //       label: 'menu.conversations.reply-templates',
  //       to: '/app/pages/conversations/replytemplates',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'HolidaysPark',
  //         'QuarantineBot',
  //         'BusinessOperator',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'Restaurant',
  //         'UtilityProviders',
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 'virtualfrontdesk',
  //   icon: 'iconsminds-police d-block',
  //   label: 'menu.virtualfrontdesk',
  //   to: '/app/pages/propinfo/services',
  //   domains: [
  //     'AccommodationProviders',
  //     'RetirementHomes',
  //     'Salons',
  //     'HolidaysPark',
  //     'QuarantineBot',
  //     'HolidayHomes',
  //     'VirtualVetNurse',
  //     'AllGroups',
  //     'Tourism',
  //     'Doctors',
  //     'Northable',
  //     'Golf',
  //     'Activities',
  //     'Restaurant',
  //     'UtilityProviders',
  //   ],
  //   subs: [
  //     {
  //       icon: 'iconsminds-bar-chart-4',
  //       label: 'menu.dashboards',
  //       to: '/app/pages/propinfo/services',
  //       domains: [
  //         'AccommodationProviders',
  //         'Salons',
  //         'Doctors',
  //         'Activities',
  //         'HolidayHomes',
  //         'Restaurant',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-information',
  //       label: 'virtual-front.common-questions',
  //       to: '/app/pages/propinfo/property-front-desk',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'QuarantineBot',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'Restaurant',
  //         'UtilityProviders',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-gift-box',
  //       label: 'virtual-front.guest-service-add-on-upsells',
  //       to: '/app/pages/propinfo/services',
  //       domains: [
  //         'AccommodationProviders',
  //         'Salons',
  //         'Doctors',
  //         'Activities',
  //         'HolidaysPark',
  //         'HolidayHomes',
  //         'Restaurant',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-gift-box',
  //       label: 'menu.guestservice',
  //       to: '/app/pages/propinfo/services',
  //       domains: ['QuarantineBot'],
  //     },
  //     // {
  //     //   icon: 'iconsminds-basket-coins',
  //     //   label: 'menu.guestservice',
  //     //   to: '/app/pages/propinfo/service-order',
  //     //   domains: ['AccommodationProviders', 'HolidayHomes'],
  //     // },
  //     {
  //       icon: 'iconsminds-inbox-out',
  //       label: 'virtual-front.outbound',
  //       to: '/app/pages/propinfo/outbound',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'HolidaysPark',
  //         'QuarantineBot',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'Restaurant',
  //         'UtilityProviders',
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-book',
  //       label: 'menu.formbuilder',
  //       to: '/app/pages/propinfo/forms',
  //       domains: [
  //         'AccommodationProviders',
  //         'RetirementHomes',
  //         'Salons',
  //         'HolidaysPark',
  //         'QuarantineBot',
  //         'HolidayHomes',
  //         'VirtualVetNurse',
  //         'AllGroups',
  //         'Tourism',
  //         'Doctors',
  //         'Northable',
  //         'Golf',
  //         'Activities',
  //         'Restaurant',
  //         'UtilityProviders',
  //         'BusinessOperator'
  //       ],
  //     },
  //     {
  //       icon: 'iconsminds-gift-box',
  //       label: 'virtual-messenger',
  //       to: '/app/pages/propinfo/messenger',
  //       domains: [
  //         'AccommodationProviders',
  //         'Salons',
  //         'Doctors',
  //         'Activities',
  //         'HolidaysPark',
  //         'HolidayHomes',
  //         'Restaurant',
  //         'AllGroups',
  //         'UtilityProviders',
  //       ],
  //     },
  //   ],
  // },

  {
    id: 'spaceBookings',
    icon: 'iconsminds-police d-block',
    label: 'dashboards.space-booking',
    to: '/app/pages/spaces',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
      'Restaurant',
      'UtilityProviders',
    ],
    subs: [
      {
        icon: 'iconsminds-space-needle',
        label: 'menu.spaces',
        to: '/app/pages/spaces',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-money-bag',
        label: 'menu.availability',
        to: '/app/pages/arispace',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-pantone',
        label: 'menu.bookingsmenu',
        to: '/app/pages/spaceBookings',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-gear',
        label: 'menu.settings',
        to: '/app/pages/spaceSettings',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-information',
        label: 'menu.help',
        to: 'https://help.myma.ai/en/articles/8695656-space-booking-engine',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
        newWindow: true,
      },
    ],
  },
  {
    id: 'Setting',
    icon: 'iconsminds-gear',
    label: 'menu.settings',
    to: '/app/pages/spaceSettings',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'HolidayHomes',
      'VoucherEngine',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
      'BusinessOperator',
      'Activities',
      'Restaurant',
      'UtilityProviders',
    ],
    subs: [
      {
        icon: 'iconsminds-speach-bubble-3',
        label: 'menu.channel',
        to: '/app/pages/integration/channels',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VoucherEngine',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'BusinessOperator',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-synchronize',
        label: 'menu.application',
        to: '/app/pages/integration/applications',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VoucherEngine',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'BusinessOperator',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-lock-2',
        label: 'menu.userroles',
        to: '/app/pages/admin',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'BusinessOperator',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-assistant',
        label: 'menu.conversations.active',
        to: '/app/pages/conversations/replytemplates',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'BusinessOperator',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-plane',
        label: 'Setup Wizard',
        to: '/app/pages/templates',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidaysPark',
          'HolidayHomes',
          'Restaurant',
          'AllGroups',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      {
        icon: 'iconsminds-business-man',
        label: 'menu.myAccounts',
        to: '/app/pages/sa/myaccount',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'BusinessOperator',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
    ],
  },
  // {

  //   id: 'tickets',
  //   icon: 'iconsminds-check d-block',
  //   label: 'menu.tickets',
  //   to: '/app/pages/tickets',
  //   domains: [
  //     'AccommodationProviders',
  //     'RetirementHomes',
  //     'Salons',
  //     'HolidaysPark',
  //     'QuarantineBot',
  //     'HolidayHomes',
  //     'VirtualVetNurse',
  //     'AllGroups',
  //     'Tourism',
  //     'Doctors',
  //     'Northable',
  //     'Golf',
  //   ],
  // },
  // {
  //   id: 'integration',
  //   icon: 'iconsminds-equalizer',
  //   label: 'menu.integration',
  //   to: '/app/pages/integration',
  //   domains: [
  //     'AccommodationProviders',
  //     'RetirementHomes',
  //     'Salons',
  //     'HolidaysPark',
  //     'QuarantineBot',
  //     'HolidayHomes',
  //     'VoucherEngine',
  //     'VirtualVetNurse',
  //     'AllGroups',
  //     'Tourism',
  //     'Doctors',
  //     'Northable',
  //     'Golf',
  //     'BusinessOperator',
  //     'Activities',
  //     'Restaurant',
  //     'UtilityProviders',
  //   ],
  // },
  // {
  //   id: 'admin',
  //   icon: 'iconsminds-security-settings',
  //   label: 'menu.userroles',
  //   to: '/app/pages/admin',
  //   domains: [
  //     'AccommodationProviders',
  //     'RetirementHomes',
  //     'Salons',
  //     'HolidaysPark',
  //     'QuarantineBot',
  //     'VoucherEngine',
  //     'HolidayHomes',
  //     'VirtualVetNurse',
  //     'AllGroups',
  //     'Tourism',
  //     'Doctors',
  //     'BusinessOperator',
  //     'Northable',
  //     'Golf',
  //     'Activities',
  //     'Restaurant',
  //     'UtilityProviders',
  //   ],
  // },
  {
    id: 'ratesbookings',
    icon: 'iconsminds-pantone d-block',
    label: 'menu.ratebookings',
    to: '/app/pages/rates-bookings',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'VoucherEngine',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
      'Restaurant',
      'UtilityProviders',
    ],
    subs: [
      {
        icon: 'iconsminds-money-bag',
        label: 'menu.ari',
        to: '/app/pages/ari',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-pantone',
        label: 'menu.bookingsmenu',
        to: '/app/pages/bookings',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-basket-coins',
        label: 'rate-promo.rate-plans',
        to: '/app/pages/rate-promos/rate-plans',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-tag',
        label: 'rate-promo.rate-plan-promos',
        to: '/app/pages/rate-promos/rate-plan-promos',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-plug-in',
        label: 'rate-promo.rate-plan-addons',
        to: '/app/pages/rate-promos/rate-plan-addons',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-male-female',
        label: 'menu.guests',
        to: '/app/pages/rate-promos/checkin-guests',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      // {
      //   icon: 'iconsminds-qr-code',
      //   label: 'Vouchers',
      //   to: '/app/pages/vouchers',
      //   domains: [
      //     'AccommodationProviders',
      //     'HolidaysPark1',
      //     'QuarantineBot1',
      //     'HolidayHomes1',
      //   ],
      // },
      // {
      //   icon: 'iconsminds-shopping-cart',
      //   label: 'Orders',
      //   to: '/app/pages/orders',
      //   domains: [
      //     'AccommodationProviders',
      //     'HolidaysPark',
      //     'QuarantineBot',
      //     'HolidayHomes',
      //   ],
      // },
    ],
  },
  // {
  //   id: 'vouchers',
  //   icon: 'iconsminds-qr-code d-block',
  //   label: 'Vouchers',
  //   to: '/app/pages/vouchers',
  //   domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  //   subs: [
  //     {
  //       icon: 'iconsminds-bar-chart-4',
  //       label: 'Insights',
  //       to: '/app/pages/insights',
  //       domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  //     },
  //     {
  //       icon: 'iconsminds-qr-code',
  //       label: 'Vouchers',
  //       to: '/app/pages/vouchers',
  //       domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  //     },
  //     {
  //       icon: 'iconsminds-shopping-cart',
  //       label: 'Orders',
  //       to: '/app/pages/orders',
  //       domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  //     },
  //     {
  //       icon: 'iconsminds-email',
  //       label: 'Invitations',
  //       to: '/app/pages/invitations',
  //       domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  //     },
  //   ],
  // },
  {
    id: 'billing',
    icon: 'iconsminds-pantone d-block',
    label: 'Billing',
    to: '/app/pages/billing',
    domains: [
      'AccommodationProviders1',
      'RetirementHomes1',
      'Salons1',
      'HolidaysPark1',
      'QuarantineBot1',
      'HolidayHomes1',
    ],
    subs: [
      {
        icon: 'iconsminds-money-bag',
        label: 'Subscription',
        to: '/app/pages/billing/subscription',
        domains: [
          'AccommodationProviders1',
          'RetirementHomes1',
          'Salons1',
          'HolidaysPark1',
          'QuarantineBot1',
          'HolidayHomes1',
        ],
      },
    ],
  },
  {
    id: 'sa',
    icon: 'iconsminds-king-2',
    label: 'menu.super-admin',
    to: '/app/pages/sa',
    type: 'sa',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'VoucherEngine',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'BusinessOperator',
      'Northable',
      'Golf',
      'Restaurant',
      'UtilityProviders',
    ],

    subs: [
      // {
      //   icon: 'iconsminds-bar-chart-4',
      //   label: 'menu.admin-insights',
      //   to: '/app/pages/sa/insights',
      //   domains: [
      //     'AccommodationProviders',
      //     'RetirementHomes',
      //     'Salons',
      //     'HolidaysPark',
      //     'QuarantineBot',
      //     'VoucherEngine',
      //     'HolidayHomes',
      //     'VirtualVetNurse',
      //     'AllGroups',
      //     'Tourism',
      //     'Doctors',
      //     'BusinessOperator',
      //     'Northable',
      //     'Golf',
      //     'Activities',
      //     'Restaurant',
      //     'UtilityProviders',
      //   ],
      // },
      {
        icon: 'iconsminds-business-man-woman',
        label: 'property-info.allcustomers',
        to: '/app/pages/sa/groups',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'BusinessOperator',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      // {
      //   icon: 'iconsminds-home-1',
      //   label: 'menu.properties',
      //   to: '/app/pages/sa/properties',
      //   domains: [
      //     'AccommodationProviders',
      //     'RetirementHomes',
      //     'Salons',
      //     'HolidaysPark',
      //     'QuarantineBot',
      //     'VoucherEngine',
      //     'BusinessOperator',
      //     'HolidayHomes',
      //     'VirtualVetNurse',
      //     'AllGroups',
      //     'BusinessOperator',
      //     'Tourism',
      //     'Doctors',
      //     'Northable',
      //     'Golf',
      //     'Activities',
      //     'Restaurant',
      //     'UtilityProviders',
      //   ],
      // },
      {
        icon: 'iconsminds-control-2',
        label: 'menu.service-provider',
        to: '/app/pages/sa/service-providers',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'BusinessOperator',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'BusinessOperator',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-space-needle',
        label: 'menu.spaces',
        to: '/app/pages/spaces',
        domains: [
          'AccommodationProviders',
          'Salons',
          'Doctors',
          'Activities',
          'HolidayHomes',
          'Restaurant',
        ],
      },
      {
        icon: 'iconsminds-pantone',
        label: 'menu.ratebookings',
        to: '/app/pages/rates-bookings',
        domains: [
          'AccommodationProviders',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VoucherEngine',
        ],
        subs: [
          {
            icon: 'iconsminds-money-bag',
            label: 'menu.ari',
            to: '/app/pages/ari',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          {
            icon: 'iconsminds-money-bag',
            label: 'Space Availability',
            to: '/app/pages/arispace',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          {
            icon: 'iconsminds-pantone',
            label: 'menu.bookingsmenu',
            to: '/app/pages/bookings',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          {
            icon: 'iconsminds-money-bag',
            label: 'Space Bookings',
            to: '/app/pages/spaceBookings',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          {
            icon: 'iconsminds-basket-coins',
            label: 'rate-promo.rate-plans',
            to: '/app/pages/rate-promos/rate-plans',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          {
            icon: 'iconsminds-tag',
            label: 'rate-promo.rate-plan-promos',
            to: '/app/pages/rate-promos/rate-plan-promos',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          {
            icon: 'iconsminds-plug-in',
            label: 'rate-promo.rate-plan-addons',
            to: '/app/pages/rate-promos/rate-plan-addons',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          {
            icon: 'iconsminds-male-female',
            label: 'menu.guests',
            to: '/app/pages/rate-promos/checkin-guests',
            domains: [
              'AccommodationProviders',
              'HolidaysPark',
              'QuarantineBot',
              'HolidayHomes',
              'VoucherEngine',
            ],
          },
          // {
          //   icon: 'iconsminds-qr-code',
          //   label: 'Vouchers',
          //   to: '/app/pages/vouchers',
          //   domains: [
          //     'AccommodationProviders',
          //     'HolidaysPark1',
          //     'QuarantineBot1',
          //     'HolidayHomes1',
          //   ],
          // },
          // {
          //   icon: 'iconsminds-shopping-cart',
          //   label: 'Orders',
          //   to: '/app/pages/orders',
          //   domains: [
          //     'AccommodationProviders',
          //     'HolidaysPark',
          //     'QuarantineBot',
          //     'HolidayHomes',
          //   ],
          // },
        ],
      },
      {
        icon: 'iconsminds-plane',
        label: 'property-info.sprint',
        to: '/app/pages/propinfo/copilot',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'QuarantineBot',
          'Tourism',
          'HolidaysPark',
          'HolidayHomes',
          'Activities',
          'AllGroups',
          'Restaurant',
        ],
      },
    ],
  },
  {
    id: 'guestmessaging',
    icon: 'iconsminds-megaphone',
    label: 'menu.guest-messaging',
    to: '/app/pages/guest-messaging',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
      'Restaurant',
      'UtilityProviders',
    ],
    subs: [
      {
        icon: 'iconsminds-gear',
        label: 'guest-messaging.settings',
        to: '/app/pages/guest-messaging/guest-setting',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-inbox-out',
        label: 'guest-messaging.outreach-setup',
        to: '/app/pages/propinfo/outbound',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Activities',
          'Restaurant',
          'UtilityProviders',
          'BusinessOperator',
        ],
      },
      {
        icon: 'iconsminds-calendar-4',
        label: 'guest-messaging.reservations',
        to: '/app/pages/guest-messaging/reservations',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-management',
        label: 'guest-messaging.work-orders',
        to: '/app/pages/guest-messaging/work-orders',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
      {
        icon: 'iconsminds-clock-forward',
        label: 'guest-messaging.insights_logs',
        to: '/app/pages/guest-messaging/insights-logs',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
          'Restaurant',
          'UtilityProviders',
        ],
      },
    ],
  },
  // {
  //   id: 'ari',
  //   icon: 'iconsminds-money-bag',
  //   label: 'menu.ari',
  //   to: '/app/pages/ari',
  //   domains: ['AccommodationProviders']
  // },

  // {
  //   id: 'rate-promos',
  //   icon: 'iconsminds-tag-3',
  //   label: 'menu.rate-promos',
  //   to: '/app/pages/rate-promos',
  //   domains: ['AccommodationProviders'],
  //   subs: [
  //     {
  //       icon: 'iconsminds-basket-coins',
  //       label: 'rate-promo.rate-plans',
  //       to: '/app/pages/rate-promos/rate-plans',
  //       domains: ['AccommodationProviders']
  //     },
  //     {
  //       icon: 'iconsminds-plug-in',
  //       label: 'rate-promo.rate-plan-addons',
  //       to: '/app/pages/rate-promos/rate-plan-addons',
  //       domains: ['AccommodationProviders']
  //     },
  //     {
  //       icon: 'iconsminds-tag',
  //       label: 'rate-promo.rate-plan-promos',
  //       to: '/app/pages/rate-promos/rate-plan-promos',
  //       domains: ['AccommodationProviders']
  //     },
  //   ],
  // },

  // {
  //   id: 'finance',
  //   icon: 'iconsminds-formula d-block',
  //   label: 'menu.finance',
  //   to: '/app/pages/finance',
  //   domains: ['AccommodationProviders', 'RetirementHomes']
  // },
  // {
  //   id: 'bookings',
  //   icon: 'iconsminds-pantone d-block',
  //   label: 'menu.bookings',
  //   to: '/app/pages/bookings',
  //   domains: ['AccommodationProviders']
  // }
];
export default data;
